document.addEventListener("DOMContentLoaded", function () {
  const dropdownConfigs = [
    {
      wrapper: document.getElementById('opportunities-wrapper'),
      link: document.getElementById('opportunities-link'),
      dropdown: document.getElementById('mega-dropdown'),
      direction: 'left'
    },
    {
      wrapper: document.getElementById('about-wrapper'),
      link: document.getElementById('about-link'),
      dropdown: document.getElementById('about-dropdown')
    },
    {
      wrapper: document.getElementById('shop-wrapper'),
      link: document.getElementById('shop-link'),
      dropdown: document.getElementById('shop-dropdown'),
      direction: 'right'
    }
  ];

  const header = document.querySelector('header');

  dropdownConfigs.forEach(({ wrapper, link, dropdown }) => {
    let isHovering = false;
    let isDropdownOpen = false;

    function showDropdown() {
      dropdown.classList.add('active');
      wrapper.classList.add('active-underline');
      isDropdownOpen = true;
    }

    function hideDropdown() {
      dropdown.classList.remove('active');
      wrapper.classList.remove('active-underline');
      isDropdownOpen = false;
    }

    wrapper?.addEventListener('mouseenter', () => {
      isHovering = true;
      showDropdown();
    });

    [wrapper, dropdown, header].forEach(el => {
      el?.addEventListener('mouseenter', () => {
        isHovering = true;
        if (isDropdownOpen) showDropdown();
      });

      el?.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (
            !wrapper?.matches(':hover') &&
            !dropdown?.matches(':hover') &&
            !header?.matches(':hover')
          ) {
            isHovering = false;
            hideDropdown();
          }
        }, 100);
      });
    });

    dropdownConfigs.forEach(other => {
      if (other.wrapper !== wrapper) {
        other.wrapper?.addEventListener('mouseenter', () => {
          hideDropdown();
        });
      }
    });

    document.addEventListener('mousemove', (e) => {
      const dropdownRect = dropdown.getBoundingClientRect();
      if (isDropdownOpen && e.clientY > dropdownRect.bottom + 100) {
        hideDropdown();
      }
    });
  });
});







const marketplaceContainer = document.querySelector('.marketplace-container');
const marketplaceLogos = document.querySelectorAll('.marketplace-container img');
const numDuplicates = 50;
for (let i = 0; i < numDuplicates; i++) {
    marketplaceLogos.forEach(logo => {
        marketplaceContainer.appendChild(logo.cloneNode(true));
    });
}
marketplaceContainer.style.width = `${marketplaceLogos.length * numDuplicates * 150}px`;

